var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconChipClose = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  preserveAspectRatio: "none",
  overflow: "visible",
  style: {
    display: "block"
  },
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Frame"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M12 4L4.00054 11.9995M11.9995 12L4 4.00057",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconChipClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-chip-close.179900c59b14ccafdacefa2b4fb42b64.svg";